export const SignaturePerson = Object.freeze({
  COLABORADOR: "COLABORADOR",
  JEFE_INMEDIATO: "JEFE_INMEDIATO",
  CARGO: "CARGO",
  CARGO_Y_SEDE: "CARGO_Y_SEDE",
});
